import React from 'react';
import styled from 'styled-components';
import { AVIFHeadTextComponent } from './AVIFCommonComponents';
import { GoToIcon } from 'assets/icons';
import { BB } from 'global-styles';
import AVIFSpeedQualityTestImageArea from './AVIFSpeedQualityTestImageArea';
import imgA from 'public/asset/product/pulsar/05-AVIF/yacht/a.png';
import imgB from 'public/asset/product/pulsar/05-AVIF/yacht/b.jpg';
import imgD from 'public/asset/product/pulsar/05-AVIF/yacht/d.png';
import Link from 'next/link';

const AvifSQTestCondition = () => {
  return (
    <AvifSQTestConditionContainer>
      <AVIFHeadTextComponent>
        AVIF Speed/Quality Benchmark
      </AVIFHeadTextComponent>

      <AVIFSpeedQualityImgs />

      <Link href="/avif-speed-quality-benchmark">
        <a className="read-more-link">
          <span className="svg-t">Read more in details</span>
          <span className="svg-g-t">
            <GoToIcon size="18" />
          </span>
        </a>
      </Link>
    </AvifSQTestConditionContainer>
  );
};

export default AvifSQTestCondition;

const AvifSQTestConditionContainer = styled.div`
  padding-top: 48px;
  .read-more-link {
    display: flex;
    height: 64px;
    background: #f2f2f2;
    align-items: center;
    margin-top: 24px;
    border-radius: 9999px;
    font-family: 'Noto Sans KR', sans-serif;
    font-size: 17px;
    font-weight: 700;
    color: ${BB};
    padding-left: 32px;
  }
  .read-more-link:hover .svg-t {
    text-decoration: underline;
  }
  .svg-t,
  .svg-w,
  .svg-g-t {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .svg-w {
    width: 76px;
    height: 32px;
    transform: rotate(180deg);
  }
  .svg-g-t {
    width: 66px;
    height: 30px;
  }
`;

export const AVIFSpeedQualityImgs = () => {
  return (
    <AVIFSpeedQualityImgsContainer>
      <AVIFSpeedQualityTestImageArea
        src={imgA.src}
        imgOgCompText="(a) original"
        sizeAndContainerText="PNG / 582.9kb"
        paddingTopPercentage="150%"
        priority
      />
      <AVIFSpeedQualityTestImageArea
        src={imgB.src}
        imgOgCompText="(b) compressed"
        sizeAndContainerText="jpeg / 16.2kb"
        scoreText="psnr=34.19, ssim=0.914, vmaf=81.4"
        paddingTopPercentage="150%"
        priority
      />
      <AVIFSpeedQualityTestImageArea
        src={imgD.src}
        imgOgCompText="(d) compressed"
        sizeAndContainerText="pulsar avif / 7.1kb"
        scoreText="psnr=35.49, ssim=0.927, vmaf=77.6"
        paddingTopPercentage="150%"
        priority
      />
    </AVIFSpeedQualityImgsContainer>
  );
};

const AVIFSpeedQualityImgsContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 12px;
  @media screen and (max-width: 904px) {
    flex-direction: column;
  }
`;
